import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const fetchNotificationsData = createAsyncThunk(
    'users/fetchNotificationsData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getNotifications();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Notifications');
        }
    }
);

export const seenAllNotifications = createAsyncThunk(
    'users/seenAllNotifications',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.seenAllNotifications();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Notifications');
        }
    }
);

const initialState = {
    notification: [],
    unSeenCount: 0,
    meta: {},
    loading: false,
    error: null,
    seenAllSuccess: false,
    seenAllFailed: false,
};

const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotificationsData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNotificationsData.fulfilled, (state, action) => {
                state.loading = false;
                state.notification = action.payload?.data?.results || [];
                state.unSeenCount = parseInt(action?.payload?.data?.unseenCount) || 0;
                state.meta = action.payload?.data?.meta || {};
                state.error = null;
            })
            .addCase(fetchNotificationsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.data = [];
            })
            .addCase(seenAllNotifications.pending, (state) => {
                state.seenAllSuccess = false;
                state.seenAllFailed = false;
            })
            .addCase(seenAllNotifications.fulfilled, (state, action) => {
                state.seenAllSuccess = true;
                state.seenAllFailed = false;
            })
            .addCase(seenAllNotifications.rejected, (state, action) => {
                state.seenAllSuccess = false;
                state.seenAllFailed = true;
            })
    },
});

export const { setCurrentPage, clearError, clearSingleUser } = userSlice.actions;

export default userSlice.reducer;
